class PuppetProfilesOrder {
  constructor(el) {
    this.$ = window.$;
    this.$el = this.$(el);
    if (this.$el.length > 0) {
      this.render();
    }
  }

  get dom() {
    return {
      PUPPET_PROFILES: '.puppet_profiles_placeholder',
    };
  }

  render() {
    this.$el
      .find(this.dom.PUPPET_PROFILES)
      .on('select2:select', () => this._profilesChanged());
    this.$el
      .find(this.dom.PUPPET_PROFILES)
      .on('select2:unselect', () => this._profilesChanged());

    setTimeout(() => {
      this._profilesChanged();
      Sortable.create(
        this.$el.find(
          '.puppet_profiles_container ul.select2-selection__rendered',
        )[0],
        {
          handle: '.select2-selection__choice',
          onSort: () => {
            var $select2 = this.$el.find(this.dom.PUPPET_PROFILES);

            this.$el
              .find(
                this.$el
                  .find('.puppet_profiles_container ul')
                  .find('.select2-selection__choice')
                  .get()
                  .reverse(),
              )
              .each((i, item) => {
                $select2.prepend(
                  $select2.find(
                    'option[value="' + $(item).data('select2-id').id + '"]',
                  )[0],
                );
              });
            this._profilesChanged();
          },
        },
      );
    }, 500);
  }

  _currentProfiles() {
    var selected = [];

    this.$el
      .find(
        '.puppet_profiles_container ul.select2-selection__rendered .select2-selection__choice',
      )
      .each((i, item) => {
        selected.push(this._getProfile($(item).attr('title')));
      });

    return selected;
  }

  _profilesChanged() {
    var selected = [];

    this._currentProfiles().map(function (item) {
      selected.push(
        '<input type="hidden" name="puppet_profiles[]" value="' +
          item.value +
          '" />',
      );
    });
    this.$el.find('.puppet_profiles_values').html(selected.join(''));
  }

  _getProfile(name) {
    var filtered = this._puppetProfilesOptions().filter(function (item) {
      return item.label == name;
    });

    return filtered.length > 0 ? filtered[0] : undefined;
  }

  _puppetProfilesOptions() {
    var options = this.$el.find(this.dom.PUPPET_PROFILES + ' option'),
      profiles = [];

    options.each(function (i, item) {
      profiles.push({
        value: $(item).attr('value'),
        label: $(item).text(),
      });
    });

    return profiles;
  }
}

module.exports = PuppetProfilesOrder;
